import { CheckCircle2, DoorOpen } from 'lucide-react';

interface DiningRoomStatsProps {
  total: number;
  active: number;
}

const DiningRoomStats = ({ total, active }: DiningRoomStatsProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 border-b border-stroke bg-gray-2/40 p-5 dark:border-strokedark dark:bg-meta-4/20 md:grid-cols-2">
      <div className="rounded-xl border border-stroke bg-white p-5 shadow-sm dark:border-strokedark dark:bg-boxdark">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-bodydark2">
              Salones registrados
            </p>

            <h2 className="mt-2 text-3xl font-bold text-black dark:text-white">
              {total}
            </h2>
          </div>

          <div className="rounded-xl bg-primary/10 p-3 text-primary">
            <DoorOpen className="h-6 w-6" />
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-stroke bg-white p-5 shadow-sm dark:border-strokedark dark:bg-boxdark">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-bodydark2">
              Activos en esta página
            </p>

            <h2 className="mt-2 text-3xl font-bold text-success">{active}</h2>
          </div>

          <div className="rounded-xl bg-success/10 p-3 text-success">
            <CheckCircle2 className="h-6 w-6" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiningRoomStats;
